import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/`;
// const SERVER_URL = "http://localhost:3000/";



const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          دیکشنری سریع (پاپ آپ)
        </Typography>
        <Typography sx={{ p: 1 }}>
          قرار دادن دو زیرنویس همزمان برای یادگیری زبان از طریق فیلم  به زبان آموز  کمک می کند که معنی جمله را درک کند . اما ممکن است درون جمله چند کلمه از کلماتی که مربوط سطح خودش باشد را بلد نباشد و یا بصورت کلی معنی کلمه ای در درون جمله را نیاز داشته باشد ، به این منظور برنامه umlang با استفاده از دیکشنری آنلاین به زبان آموز کمک می کند که بتواند معنی کلمه را پیدا نماید.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "45%" }} src={`${SERVER_URL}img/slider/slide4-img1.png`} />
        </Typography>
        <Typography sx={{ p: 1 }}>
          دیشکنری پاپ آپ به راحت ترین روش ممکن در اختیار کاربر قرار گرفته و نحوه عملکرد آن به این صورت است که هنگام پخش فیلم و زیرنویس کاربر موس را بر روی لغت برده و ترجمه های لغت برای کاربر نمایش داده می شود و اگر با گوشی موبایل مشغول تماشای فیلم می باشید با تاچ کردن لغت ترجمه آن نمایش داده خواهد شد.
        </Typography>
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          ذخیره لغت
        </Typography>
        <Typography sx={{ p: 1 }}>
          زبان آموز با تماشای فیلم با دو زیرنویس و با استفاده از دیکشنری پاپ آپ می تواند ترجمه جمله و لغت را مشاهده کند ، اما ذهن انسان با یکبار مشاهده قادر به حفظ لغت نمی باشد و نیاز است که این لغت را ذخیره و بعدا مرور کند ، به همین دلیل ما ویژگی ذخیره لغت را برای کاربر گذاشته ایم که بتواند لغت مورد نظر به همراه  ترجمه های آن را به راحتی و تنها با یک کلیک ذخیره نمایید.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "45%" }} src={`${SERVER_URL}img/slider/slide4-img2.png`} />
        </Typography>
        <Typography sx={{ p: 1 }}>
          باتوجه به اینکه یک لغت ممکن است دارای چندین ترجمه باشد اما کاربر قصد یادگیری فقط یک معنی را داشته باشد و یا بخواهد با کمی تغییر در کلمه و ترجمه آن را ذخیره کند ، ما این ویژگی را برای کاربر گذاشته ایم که بتواند چنین مدیریتی را بر روی لغت انجام دهد.
        </Typography>
      </DemoPaper>
    </>
  )
}


export default Slide1Content;
